import { Helpers, LifeCycle } from 'entities/lifecycle';

interface EntityWithName {
  id?: string;
  name?: string;
}

export const Filters = {
  nameIncludes: (substring: string) => (entity: EntityWithName) =>
    entity.name ? entity.name.toLowerCase().indexOf(substring.toLowerCase()) > -1 : false,

  lifecycleStatus: (status: string) => (lifeCycle: LifeCycle) => {
    const { state } = lifeCycle;
    const activity = Helpers.getActivityState(lifeCycle);

    switch (status) {
      case 'all':
        return state !== 'DELETED';

      case 'live':
        return activity === 'Live';

      case 'testing':
        return state === 'TESTING';

      case 'inactive':
        return state === 'INACTIVE' || activity === 'Finished' || activity === 'Scheduled';

      case 'archived':
        return state === 'DELETED';
    }
  },
};
